module.exports = __webpack_public_path__ + "static/media/girl2.64e0eae6.png";